"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepareEnvMessage = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Messages_1 = require("../../../../Messages");
exports.PrepareEnvMessage = function (props) {
    var integrationDocLink = props.integrationDocLink;
    if (integrationDocLink) {
        return (react_1.default.createElement(Messages_1.Message, { type: "progress", className: "embed-insight-dialog-prep-env-message" },
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "embedInsightDialog.prepareEnvironmentMessage", values: { b: function (chunks) { return react_1.default.createElement("strong", null, chunks); } } })),
            react_1.default.createElement("a", { href: integrationDocLink, target: "_blank", rel: "noreferrer" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "embedInsightDialog.prepareEnvironmentMessage.link" }))));
    }
    return null;
};
//# sourceMappingURL=PrepareEnvMessage.js.map